export const MultiSelectStyles = {
  option: (provided: any, state: any) => ({
    ...provided,
    color: 'black',
    background: state.isFocused ? 'var(--serty-green)' : 'white',
    padding: 10,
  }),
  control: (provided: any, state: any) => ({
    ...provided,
    border: '1px solid #dbdbdb',
    outline: 'none'
  }),
  singleValue: (provided: any, state: any) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = 'opacity 300ms';

    return { ...provided, opacity, transition };
  },
  dropdownIndicator: (provided: any, state: any) => ({
    ...provided,
    background: [
      'var(--serty-green)',
      'linear-gradient(#76ac2f, #3c5718)'
    ],
    marginTop: 0
  }),
  indicatorsContainer: (provided: any, state: any) => ({
    ...provided,
  }),
  indicatorSeparator: () => ({
    display: 'none'
  }),
  menuList: (provided: any, state: any) => ({
    ...provided,
    padding: 0
  }),
  valueContainer: (provided: any, state: any) => ({
    ...provided,
    paddingTop: 0,
    flexWrap: 'nowrap'
  }),
  multiValueRemove: (provided: any, state: any) => ({
    ...provided,
    ':hover': {
      backgroundColor: 'var(--serty-green)',
    }
  })
}
